angular.module('eStories.review.model', [

    /*eStories.review.model*/

])
    .service('ReviewModel', ['WS', 'ModalsModel', 'LL', function (WS, ModalsModel, LL) {

        var model = this;

        model.myRating = null;
        model.libraryAudiobookToRate = null;

        model.getReviewAudiobookError = function (response) {
            switch (response.responseText) {
                case 'INVALID_RATING' :
                    return 'You must choose a star rating';

                case 'MISSING_REVIEW_OR_RATING':
                    return 'Missing Review or Rating';

                case 'REVIEW_HEADLINE_MISSING':
                    return 'Review headline missing';

                case 'REVIEW_BODY_MISSING':
                    return 'Review body missing';

                case 'REVIEW_HEADLINE_CHAR_LIMIT_EXCEEDED':
                    return 'Review headline character limit exceeded';

                case 'REVIEW_BODY_CHAR_LIMIT_EXCEEDED':
                    return 'Review body character limit exceeded';

            }
        };

        model.deleteReview = function (reviewId) {
            return WS.callServer('library/deleteReview', {reviewId: reviewId});
        };

        model.reviewAudiobook = (audiobookId,
                                 rating,
                                 reviewHeadline,
                                 reviewBody) => {

            const audiobookReviewObj = {
                audiobookId: audiobookId,
                rating: rating,
                reviewHeadline: reviewHeadline,
                reviewBody: reviewBody
            };

            const tagObj = {
                'Rate': rating,
                'Review': reviewBody
            };

            LL.tagEvent('Gave feedback', tagObj);
            return WS.callServer('library/reviewAudiobook', audiobookReviewObj);

        };

        model.openReviewModal = function () {
            ModalsModel.open("/library/review/reviewModal.tmpl.html", "ReviewModalCtrl", "reviewModalCtrl");
        }

    }])

    .controller('ReviewModalCtrl', [
        'ReviewModel',
        '$rootScope',
        '$uibModalInstance',
        '$scope',
        function (ReviewModel,
                  $rootScope,
                  $uibModalInstance,
                  $scope) {

            var reviewModalCtrl = this;

            reviewModalCtrl.libraryAudiobookToRate = ReviewModel.libraryAudiobookToRate;

            reviewModalCtrl.myRating = ReviewModel.myRating;

            $scope.$on('setRating', function (event, rating) {
                reviewModalCtrl.myRating = rating * 2;
            });

            reviewModalCtrl.setExistingReviewData = function (libraryAudiobook) {
                if (libraryAudiobook.review) {
                    reviewModalCtrl.reviewHeadline = libraryAudiobook.review.reviewHeadline;
                    reviewModalCtrl.reviewBody = libraryAudiobook.review.reviewBody;
                }
            };

            reviewModalCtrl.setExistingReviewData(ReviewModel.libraryAudiobookToRate);

            reviewModalCtrl.reviewAudiobook = async () => {

                reviewModalCtrl.serverError = null;

                const response = await ReviewModel.reviewAudiobook(
                    reviewModalCtrl.libraryAudiobookToRate.audiobook.id,
                    reviewModalCtrl.myRating / 2,
                    reviewModalCtrl.reviewHeadline,
                    reviewModalCtrl.reviewBody);
                if (response != null && response.responseStatus === 'SUCCESS') {
                    reviewModalCtrl.libraryAudiobookToRate.review = {
                        id: response.reviewId,
                        rating: reviewModalCtrl.myRating / 2,
                        reviewBody: reviewModalCtrl.reviewBody,
                        reviewHeadline: reviewModalCtrl.reviewHeadline
                    };
                    reviewModalCtrl.closeReviewModal();
                } else {
                    reviewModalCtrl.serverError = ReviewModel.getReviewAudiobookError(response);
                }

            };

            reviewModalCtrl.discardReview = function () {
                reviewModalCtrl.resetReviewData();
                reviewModalCtrl.closeReviewModal();
            };

            reviewModalCtrl.resetReviewData = function () {
                reviewModalCtrl.audiobookId = null;
                reviewModalCtrl.myRating = null;
                reviewModalCtrl.reviewHeadline = null;
                reviewModalCtrl.reviewBody = null;
                ReviewModel.libraryAudiobookToRate = null;
                ReviewModel.myRating = null;
                $rootScope.$broadcast('resetRating');
            };

            reviewModalCtrl.closeReviewModal = function () {
                $uibModalInstance.close('/library/review/reviewModal.tmpl.html');
            };

            $scope.$on('modal.closing', function () {
                reviewModalCtrl.resetReviewData();
            });
        }]);
